module.exports = __webpack_public_path__ + "assets/img/times_on.436d7e1d.svg";